
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"14","viewBox":"0 0 21 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.17 6.23L5.17.45a3 3 0 00-4 3.7L2.71 9l-1.58 4.85A3 3 0 001.94 17a3 3 0 002 .8c.395 0 .786-.079 1.15-.23l14.05-5.78a3 3 0 000-5.54l.03-.02zM4.36 15.7a1 1 0 01-1.06-.19 1 1 0 01-.27-1L4.49 10h13.73L4.36 15.7zM4.49 8L3 3.53a1 1 0 01.27-1 1 1 0 011.12-.23L18.22 8H4.49z","fill":"#ABAFB5"}})])
          )
        }
      }
    